/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import clsx from "clsx";
import {CompanyBranchType} from "types/enums/CompanyBranchType";
import {useTranslation} from "react-i18next";
import UiPill from "components/Ui/UiPill";

const UiCompanyTypePill = ({ type }: { type: CompanyBranchType }) => {
    const { t } = useTranslation()
    const isParent = type === CompanyBranchType.Parent
    const isPrivate = type === CompanyBranchType.Private
    const isCompany = type === CompanyBranchType.Company
    const isSchool = type === CompanyBranchType.School
    const isVerein = type === CompanyBranchType.Verein

    if (isPrivate) {
        return (
            <UiPill className={clsx('UiCompanyTypePill pill-tone-pink')}>
                {t('Private')}
            </UiPill>
        )
    }

    if (isCompany) {
        return (
            <UiPill className={clsx('UiCompanyTypePill pill-tone-yellow')}>
                {'Firma'}
            </UiPill>
        )
    }

    if (isSchool) {
        return (
            <UiPill className={clsx('UiCompanyTypePill pill-tone-purple')}>
                {'Schule'}
            </UiPill>
        )
    }

    if (isVerein) {
        return (
            <UiPill className={clsx('UiCompanyTypePill pill-tone-orange')}>
                {'Verein'}
            </UiPill>
        )
    }

    return (
        <UiPill
            className={clsx(
                'UiCompanyTypePill',
                isParent ? 'pill-tone-blue' : 'pill-tone-green'
            )}
        >
            {t(isParent ? 'Parent' : 'branch_company_type')}
        </UiPill>
    )
}

export default UiCompanyTypePill;
